import React from 'react';

import { Heading } from '../TypographyPublicSite';
import { BrandsContainer, StyledImage } from './styles';
import { Section } from '../styles';
import Fluid from '../../Fluid';

const BrandsShowcase = ({
  brandsShowcase: { backgroundColor = 'backgroundPrimary', title, items },
  removeBottomPadding
}) => {
  const padding = removeBottomPadding
    ? { xs: ['lg', 'none', 'none'], sm: ['2xl', 'none', 'none'] }
    : { xs: ['lg', 'none'], sm: ['2xl', 'none'] };
  return (
    <Section borderless data-color={backgroundColor} padding="md">
      <Fluid padding={padding}>
        {title ? (
          <Heading as="h4" align="center" size="sm">
            {title}
          </Heading>
        ) : null}
        {items ? (
          <BrandsContainer>
            {items.map(({ name, image, imageAlt, url }) => (
              <a key={name} href={url} target="_blank" rel="noreferrer noopener">
                <StyledImage src={image} alt={imageAlt || name} />
              </a>
            ))}
          </BrandsContainer>
        ) : null}
      </Fluid>
    </Section>
  );
};

export default BrandsShowcase;
